import { Component } from "@angular/core";

@Component({
    selector: "pl-error-message",
    templateUrl: "./error-message.component.html",
    styleUrls: ["./error-message.component.scss"],
    standalone: false
})
export class ErrorMessageComponent {}
